var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-alert',{attrs:{"title":"页面建设中","type":"error","description":"当前功能尚未开发完毕","show-icon":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }